import { LPSettlementBatchSourceEnum, LPSettlementBatchStatusEnum } from '@talos/kyoko';
import type { LPSettlementBatchMessageData } from '../generated/lpSettlementTypes';

function isBatchLocked(settlementBatch: LPSettlementBatchMessageData) {
  return settlementBatch.Status !== LPSettlementBatchStatusEnum.Created;
}

/** Display label for Created By when the batch was created automatically (not attributed to a user). */
export const LP_SETTLEMENT_AUTOMATIC_CREATED_BY_LABEL = 'System' as const;

/**
 * Resolved Created By text for batch details header and grids.
 * Automatic batches use {@link LP_SETTLEMENT_AUTOMATIC_CREATED_BY_LABEL}; otherwise `creationUser`.
 */
export function getCreatedByDisplayValue(
  creationSource: LPSettlementBatchSourceEnum | undefined,
  creationUser: string | undefined,
  options?: { whenMissingUser?: string }
): string {
  if (creationSource === LPSettlementBatchSourceEnum.Automatic) {
    return LP_SETTLEMENT_AUTOMATIC_CREATED_BY_LABEL;
  }
  return creationUser ?? options?.whenMissingUser ?? '(Unknown)';
}

/** Created By column / grouping (grid rows use Batch*-prefixed fields). */
export function getCreatedByColumnDisplayValue(
  batch: {
    BatchCreationSource?: LPSettlementBatchSourceEnum;
    BatchCreationUser?: string;
  } | null
): string {
  if (!batch) {
    return '(Unknown)';
  }
  return getCreatedByDisplayValue(batch.BatchCreationSource, batch.BatchCreationUser);
}

export { isBatchLocked };
